export default {
  properties: {
    product: { type: 'string', description: 'sku' },
    store: { type: 'string', description: 'store' },
    in_stock: { type: 'boolean', description: 'is in stock' },
    stock_level: { type: 'integer', description: 'stock level' }
  },
  additionalProperties: false,
  type: 'object',
  title: 'Stock',
  description: 'Stock',
  required: []
};
